import { tw } from "@careinfo/tailwind";
import { Editor } from "grapesjs";
import { Eye, Redo2, Save, Settings, Trash, Undo2 } from "lucide-react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import useModalEditorHook from "../../../hooks/useModalEditorHook";

const NavBar = () => {
  const { handleDeviceChange, handlePanelChange } = useModalEditorHook();
  const navigate = useNavigate();
  const editorRef = useRef<Editor | null>(null);
  return (
    <div
      className={tw`h-[50px] bg-gray-600 text-white flex items-center justify-between w-full  top-0 sticky z-1  px-4`}
    >
      <button
        className={tw`focus:outline-none px-4 py-2 border border-white rounded-md  `}
        type="button"
        onClick={() => navigate(-1)}
      >
        Back
      </button>
      <div className={tw` flex items-center justify-center `}>
        {editorRef?.current &&
          editorRef?.current?.config?.deviceManager?.devices?.map(
            (device: any) => (
              <div
                key={device?.id}
                className={tw`${device?.className} h-8 w-8 cursor-pointer p-2 hover:bg-primary-light `}
                onClick={() => handleDeviceChange(device?.id)}
              ></div>
            )
          )}
      </div>

      {/* Panels */}
      <div className={tw`flex items-center justify-center gap-4`}>
        <button
          onClick={() => handlePanelChange("undo")}
          className={tw`flex items-center gap-2 focus:outline-none `}
        >
          <Undo2 size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("redo")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Redo2 size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("save")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Save size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("delete")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Trash size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("visibility")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Eye size={20} />
        </button>
      </div>
    </div>
  );
};

export default NavBar;
